var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "combination-text",
      class: {
        "combination-text--small": _vm.size === "small",
      },
    },
    [
      _c(
        "div",
        { staticClass: "combination-text__input" },
        [
          _vm.isUseRichText
            ? _c("div", {
                staticClass: "combination-text__richeditor",
                attrs: { contenteditable: "" },
                domProps: { innerHTML: _vm._s(_vm.richText) },
                on: { blur: _vm.onTextChange },
              })
            : _c("yxt-input", {
                ref: "input",
                attrs: { type: "textarea", autosize: { minRows: 1 } },
                on: {
                  blur: _vm.trimInput,
                  focus: function ($event) {
                    return $event.currentTarget.select()
                  },
                },
                model: {
                  value: _vm.richText,
                  callback: function ($$v) {
                    _vm.richText = $$v
                  },
                  expression: "richText",
                },
              }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }